import React, { useCallback } from "react";
import ModalWrapper from "..";
import { Button } from "../../button";
import toast from "react-hot-toast";
import useAuthStore from "../../../store/Auth";
import { useTranslation } from "react-i18next";
import { useDeleteMeetingRoomById } from "../../../hooks/common/mutation";
import { DELETE_STATUSES } from "../../../constants/common";

interface DeleteDepartmentModalProps {
  meetingRoomId: number;
  isOpen: boolean;
  onOpenChange: () => void;
}

const DeleteMeetingRoomModal = ({
  meetingRoomId,
  isOpen,
  onOpenChange,
}: DeleteDepartmentModalProps) => {
  const {
    mutateAsync: DeleteMeetingRoomById,
    isPending: isDeleteMeetingRoomByIdLoading,
  } = useDeleteMeetingRoomById();

  const { t } = useTranslation();

  const user = useAuthStore((state) => state.user);

  const handleDeleteMeetingRoom = useCallback(async () => {
    try {
      if (user?.user_id) {
        const body = {
          encryptedId: meetingRoomId.toString(),
        };
        await DeleteMeetingRoomById(body);
        toast.success(t("meetingRoomDeleted"));
      }
    } catch (error: any) {
      if (error.result.deleteStatus === DELETE_STATUSES.USED_IN_APPOINTMENT) {
        toast.error(t("meetingRoomNotDeletedUsedByAppointment"));
      } else {
        toast.error(t("somethingWentWrong"));
      }
    } finally {
      onOpenChange();
    }
  }, [user?.user_id, meetingRoomId, DeleteMeetingRoomById, t, onOpenChange]);

  return (
    <ModalWrapper isOpen={isOpen} onOpenChange={onOpenChange}>
      <div className="flex flex-col gap-8 justify-center items-center">
        <p className="text-lg md:text-2xl font-medium">
          {t("confirmDeleteMeetingRoom")}
        </p>

        <div className="flex gap-1 items-center">
          <Button
            onClick={handleDeleteMeetingRoom}
            isLoading={isDeleteMeetingRoomByIdLoading}
            className=" bg-red-600 hover:bg-red-700"
          >
            {t("delete")}
          </Button>

          <Button onClick={onOpenChange}>{t("close")}</Button>
        </div>
      </div>
    </ModalWrapper>
  );
};

export default React.memo(DeleteMeetingRoomModal);
